import React from "react";
import { Helmet } from "react-helmet";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";

import Policy_img from "../../assets/img/contact.png";

export default function Policy() {
  const intl = useIntl();

  const messages = defineMessages({
    titleSEO: {
      id: "page.cookies.titleSEO",
      description: "Cookies",
      defaultMessage: "Cookies",
    },
    keywordSEO:{
      id: "page.cookies.keywordSEO",
      description: "Cookies, privacy, servers, information",
      defaultMessage: "Cookies, privacy, servers, information",
    },
    breadcrumb: {
      id: "page.cookies.breadcrumb",
      description: "page Cookies breadcrumb",
      defaultMessage: "Política de Cookies",
    },
    title: {
      id: "page.cookies.pageTitle",
      description: "page Cookies title",
      defaultMessage: "Política de Cookies",
    },
    definitionTitle: {
      id: "page.cookies.definitionTitle",
      description: "policy definition title",
      defaultMessage: "¿Qué son las cookies?",
    },
    definitionText: {
      id: "page.cookies.definitionText",
      description: "policy definition text",
      defaultMessage: "Este sitio web utiliza cookies y/o tecnologías similares que almacenan y recuperan información cuando navegas. En general, estas tecnologías pueden servir para finalidades muy diversas, como, por ejemplo, reconocerte como usuario, obtener información sobre tus hábitos de navegación, o personalizar la forma en que se muestra el contenido. Los usos concretos que hacemos de estas tecnologías se describen a continuación.",
    },
    typesTitle: {
      id: "page.cookies.typesTitle",
      description: "policy types title",
      defaultMessage: "¿Qué tipos de cookies existen?",
    },
    typesText: {
      id: "page.cookies.typesText",
      description: "policy types text",
      defaultMessage: "En función de su finalidad, las cookies pueden ser:\n\n Cookies técnicas: Son aquéllas que permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan como, por ejemplo, controlar el tráfico y la comunicación de datos, identificar la sesión, acceder a partes de acceso restringido, recordar los elementos que integran un pedido, realizar el proceso de compra de un pedido, realizar la solicitud de inscripción o participación en un evento, utilizar elementos de seguridad durante la navegación, almacenar contenidos para la difusión de videos o sonido o compartir contenidos a través de redes sociales.\n\n Cookies de personalización o preferencias: Son aquéllas que permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en función de una serie de criterios en el terminal del usuario como por ejemplo serian el idioma, el tipo de navegador a través del cual accede al servicio, la configuración regional desde donde accede al servicio, etc.\n\n Cookies de análisis: Son aquéllas que permiten al responsable de las mismas, el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma y para la elaboración de perfiles de navegación de los usuarios de dichos sitios, aplicaciones y plataformas, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.\n\n Cookies publicitarias: Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado en base a criterios como el contenido editado o la frecuencia en la que se muestran los anuncios.\n\n Cookies de publicidad comportamental: Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado. Estas cookies almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.\n\n ¿Qué cookies utilizamos? ¿Las puedo configurar? Panel de configuración de cookies.\n\n Procedemos a detallar el uso de cookies que hace esta APP con el fin de informarle con la máxima exactitud posible sobre las cookies que se utilizan en el presente entorno. Asimismo, para su facilidad le ofrecemos la posibilidad de aceptar o rechazar las cookies que le interesen, desde nuestro panel de configuración de cookies.\n\n El editor no se hace responsable ni del contenido ni de la veracidad de las políticas de privacidad que puedan tener los terceros mencionados en la presente Política de cookies.",
    },
    useTitle: {
      id: "page.cookies.useTitle",
      description: "policy use title",
      defaultMessage: "¿Quién utiliza las cookies?",
    },
    useText: {
      id: "page.cookies.useText",
      description: "policy use text",
      defaultMessage: "La información recopilada por las cookies puede ser recibida tanto por el editor de este entorno como por terceros. Debe tener en cuenta que si acepta la inclusión de cookies de terceros, para poder retirar posteriormente dichas cookies deberá acudir a las instrucciones de su navegador o las otorgadas por el propio tercero.\n\n A continuación, le facilitamos información relativa a la gestión o desactivación de cookies de los principales navegadores:\n\n",
    },
    useExplorerTitle: {
      id: "page.cookies.useExplorerTitle",
      description: "policy use explorer title",
      defaultMessage: "Configuración de cookies de Internet Explorer, ",
    },
    useExplorerLink: {
      id: "page.cookies.useExplorerLink",
      description: "policy use explorer link",
      defaultMessage: "http://windows.microsoft.com/en-us/windows/upgrade-your-browser",
    },
    useFirefoxTitle: {
      id: "page.cookies.useFirefoxTitle",
      description: "policy use firefox title",
      defaultMessage: "Configuración de cookies de Firefox, ",
    },
    useFirefoxLink: {
      id: "page.cookies.useFirefoxLink",
      description: "policy use firefox link",
      defaultMessage: "https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we",
    },
    useChromeTitle: {
      id: "page.cookies.useChromeTitle",
      description: "policy use chrome title",
      defaultMessage: "Configuración de cookies de Google Chrome, ",
    },
    useChromeSubtitle: {
      id: "page.cookies.useChromeSubtitle",
      description: "policy use chrome subtitle",
      defaultMessage: "Para  obtener información adicional sobre las políticas de tratamiento de información de Google puede acceder al siguiente",
    },
    useChromeSubtitleLink: {
      id: "page.cookies.useChromeSubtitleLink",
      description: "policy use chrome subtitle link",
      defaultMessage: "enlace.",
    },
    useChromeLink: {
      id: "page.cookies.useChromeLink",
      description: "policy use chrome link",
      defaultMessage: "https://support.google.com/chrome/answer/95647?hl=es",
    },
    useSafariTitle: {
      id: "page.cookies.useSafariTitle",
      description: "policy use safari title",
      defaultMessage: "Configuración de cookies de Safari, ",
    },
    useSafariLink: {
      id: "page.cookies.useSafariLink",
      description: "policy use safari link",
      defaultMessage: "http://support.apple.com/kb/HT1677?viewlocale=es_ES&locale=es_ES",
    },
    useWindowsTitle: {
      id: "page.cookies.useWindowsTitle",
      description: "policy use windows title",
      defaultMessage: "Configuración de cookies de Windows Phone, ",
    },
    useWindowsLink: {
      id: "page.cookies.useWindowsLink",
      description: "policy use windows link",
      defaultMessage: "https://support.microsoft.com/es-es/help/10635/windows-phone-change-privacy-and-other-browser-settings",
    },
    useSubtext: {
      id: "page.cookies.useSubtext",
      description: "policy use subtext",
      defaultMessage: "Puede consultar quién utiliza la información recibida de las cookies (el propio editor o terceros) en nuestro panel de configuración de cookies.",
    },
    conserveTitle: {
      id: "page.cookies.conserveTitle",
      description: "policy conserve title",
      defaultMessage: "¿Durante cuánto tiempo se conserva la información de las cookies?",
    },
    conserveText: {
      id: "page.cookies.conserveText",
      description: "policy conserve text",
      defaultMessage: "Puede consultar durante cuánto tiempo se conserva la información de cada tipo de cookie utilizada en nuestro panel de configuración de cookies.",
    },
    uninstallTitle: {
      id: "page.cookies.uninstallTitle",
      description: "policy uninstall title",
      defaultMessage: "¿Cómo desinstalo las cookies?",
    },
    uninstallText: {
      id: "page.cookies.uninstallText",
      description: "policy uninstall text",
      defaultMessage: "El usuario puede desinstalar e inhabilitar las cookies desde su terminal ajustando la configuración de manera que se acepte o se rechace los permisos que desee. Desde este entorno no se puede garantizar la correcta o incorrecta manipulación de las cookies desde elementos externos al mismo. Si desea tener un mayor control sobre la instalación de cookies, puede instalar programas o complementos en su dispositivo que le permitan escoger aquellas cookies que desea permitir.\n\n El editor no puede garantizar la correcta o incorrecta manipulación de las cookies por parte de los mencionados navegadores. Si desea tener un mayor control sobre la instalación de cookies, puede instalar programas o complementos a su navegador, conocidos como herramientas de “Do Not Track”, que le permitirán escoger aquellas cookies que desea permitir.\n\n El hecho de que el usuario configure su dispositivo para rechazar todas las cookies o expresamente nuestras cookies puede suponer que no sea posible acceder a algunos de los servicios y que su experiencia en este entorno pueda resultar menos satisfactoria.",
    },
    dataTitle: {
      id: "page.cookies.dataTitle",
      description: "policy data title",
      defaultMessage: "¿Dónde puedo conocer más información relativa a la protección de mis datos personales?",
    },
    dataLinkText: {
      id: "page.cookies.dataLinkText",
      description: "policy data link text",
      defaultMessage: "Puede consultar nuestra política de privacidad a través del siguiente enlace: ",
    },
    dataLinkUrl: {
      id: "page.cookies.dataLinkUrl",
      description: "policy data link url",
      defaultMessage: "Política de Privacidad",
    },
    dataText: {
      id: "page.cookies.dataText",
      description: "policy data text",
      defaultMessage: "El editor, identificado en el aviso legal, se reserva el derecho a modificar la presente Política de Cookies para adaptarla a futura legislación y/o jurisprudencia aplicable, así como a los futuros usos de los datos personales del usuario. En cualquier caso, los usuarios serán informados previamente de los cambios en la mencionada política",
    },
  });

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage(messages.titleSEO)}</title>
        <meta name="title" content={intl.formatMessage(messages.titleSEO)}/>
        <meta name="description" content=""/>
        <meta name="keywords" content={intl.formatMessage(messages.keywordSEO)}/>

        <meta property="og:type" content="website"/>
        <meta property="og:url" content="https://metatags.io/"/>
        <meta property="og:title" content={intl.formatMessage(messages.titleSEO)}/>
        <meta property="og:description" content=""/>
        <meta property="og:image" content="https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png"/>

        <meta property="twitter:card" content="summary_large_image"/>
        <meta property="twitter:url" content="https://metatags.io/"/>
        <meta property="twitter:title" content={intl.formatMessage(messages.titleSEO)}/>
        <meta property="twitter:description" content=""/>
        <meta property="twitter:image" content="https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png"/>
      </Helmet>

      <section className="contact-page half-wrapper responsive-multimedia-off">
        <div className="half-breadcrumbs color">
          <ol
            className="breadcrumbs-list"
            itemScope
            itemType="http://schema.org/BreadcrumbList"
          >
            <li
              className="breadcrumbs-list-element"
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
            >
              <a itemProp="item" href="/">
                <span className="breadcrumbs-element-text" itemProp="name">
                  Home
                </span>
              </a>
            </li>
            <li
              className="breadcrumbs-list-element active"
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
            >
              <a itemProp="item" href="/policy">
                <span className="breadcrumbs-element-text" itemProp="name">
                  <FormattedMessage {...messages.breadcrumb} />
                </span>
              </a>
            </li>
          </ol>
        </div>
        <div className="wrapper">
          <div className="wrap-contact-page">
            <header className="contact-page-header">
              <div className="wrap-contact-header">
                <h1 className="contact-header-title">
                  <FormattedMessage {...messages.title} />
                </h1>
              </div>
            </header>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-text subtitle">
                  <FormattedMessage {...messages.definitionTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.definitionText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-text subtitle">
                  <FormattedMessage {...messages.typesTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.typesText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-text subtitle">
                  <FormattedMessage {...messages.useTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.useText} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.useExplorerTitle} />
                  <a href="http://windows.microsoft.com/en-us/windows/upgrade-your-browser">
                    <FormattedMessage {...messages.useExplorerLink} />
                  </a>
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.useFirefoxTitle} />
                  <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we">
                    <FormattedMessage {...messages.useFirefoxLink} />
                  </a>
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.useChromeTitle} />
                  <a href="https://support.google.com/chrome/answer/95647?hl=es">
                    <FormattedMessage {...messages.useChromeLink} />
                  </a>
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.useChromeSubtitle} />{" "}
                  <a href="https://business.safety.google/privacy/" target="_blank">
                    <FormattedMessage {...messages.useChromeSubtitleLink} />
                  </a>
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.useSafariTitle} />
                  <a href="http://support.apple.com/kb/HT1677?viewlocale=es_ES&locale=es_ES">
                    <FormattedMessage {...messages.useSafariLink} />
                  </a>
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.useWindowsTitle} />
                  <a href="https://support.microsoft.com/es-es/help/10635/windows-phone-change-privacy-and-other-browser-settings">
                    <FormattedMessage {...messages.useWindowsLink} />
                  </a>
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-text subtitle">
                  <FormattedMessage {...messages.conserveTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.conserveText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-text subtitle">
                  <FormattedMessage {...messages.uninstallTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.uninstallText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-text subtitle">
                  <FormattedMessage {...messages.dataTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.dataLinkText} />
                  <a href="/policy">
                    <FormattedMessage {...messages.dataLinkUrl} />
                  </a>
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.dataText} />
                </p>
              </div>
            </div>
            <div className="half-multimedia">
              <div className="wrap-half-multimedia">
                <div className="half-multimedia-box">
                  <div className="wrap-multimedia-box">
                    <figure
                      className="multimedia-box-element"
                      role="img"
                      data-lazyimg={Policy_img}
                    ></figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
